

const DriverLanding = () =>{
    return(
        <div>Driver</div>
    );
}

export default DriverLanding